import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import toast from 'react-hot-toast'; // Make sure to import this
import TwoFactorAuth from './TwoFactorAuth';


import {
    Box,
    Container,
    Grid,
    Paper,
    Typography,
    Avatar,
    Button,
    Tabs,
    Tab,
    Divider,
    IconButton,
    TextField,
    Switch,
    Chip,
    useTheme,
    useMediaQuery,
    InputAdornment,
    Alert,
    Collapse
} from '@mui/material';
import {
    Edit as EditIcon,
    Security as SecurityIcon,
    Notifications as NotificationsIcon,
    Language as LanguageIcon,
    CreditCard as CreditCardIcon,
    AccountBalanceWallet as WalletIcon,
    VerifiedUser as VerifiedIcon,
    Settings as SettingsIcon,
    Visibility,
    VisibilityOff,
    LockReset as LockResetIcon
} from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
const Profile = () => {
    const [activeTab, setActiveTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isEditing, setIsEditing] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const [userData, setUserData] = useState({
        firstName: '',
        lastName: ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = Cookies.get('token');
                const response = await axios.get('/api/getuser/profile', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setUserData(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching user data:', error);
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handlePasswordChange = (field) => (event) => {
        setPasswordData({
            ...passwordData,
            [field]: event.target.value
        });
        // Clear messages
        setPasswordError('');
        setSuccessMessage('');
    };

    const validatePasswords = () => {
        if (passwordData.newPassword.length < 8) {
            setPasswordError('New password must be at least 8 characters long');
            return false;
        }
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setPasswordError('New passwords do not match');
            return false;
        }
        return true;
    };

    const handleSubmitPassword = async () => {
        if (!validatePasswords()) return;

        try {
            // API call would go here
            // await changePassword(passwordData);

            setSuccessMessage('Password changed successfully');
            setPasswordData({
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });
            setTimeout(() => {
                setShowChangePassword(false);
                setSuccessMessage('');
            }, 3000);
        } catch (error) {
            setPasswordError('Failed to change password. Please try again.');
        }
    };
    return (
        <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 4 } }}>
            {/* Profile Header */}
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 2, sm: 3 },
                    mb: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #542374 0%, #7B3AA0 100%)',
                    color: 'white'
                }}
            >
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} sm={8}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar
                                src="/path-to-profile-image.jpg"
                                sx={{
                                    width: { xs: 80, sm: 100 },
                                    height: { xs: 80, sm: 100 },
                                    border: '4px solid rgba(255, 255, 255, 0.2)'
                                }}
                            />
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="h5" fontWeight="600">
                                        {loading ? (
                                            "John Doe"
                                        ) : (
                                            `${userData.firstName || ''} ${userData.lastName || ''}`
                                        )}
                                    </Typography>
                                    {/* <VerifiedIcon sx={{ color: '#4CAF50' }} /> */}
                                </Box>
                                <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
                                    {/* ID: XPD-8547-9632 */}
                                </Typography>
                                {/* <Chip
                                    label="Verified"
                                    size="small"
                                    sx={{
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                        color: 'white',
                                        mr: 1
                                    }}
                                /> */}

                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, textTransform: 'capitalize' }}>
                            <Button
                                variant="contained"
                                startIcon={<EditIcon />}
                                onClick={() => setIsEditing(true)}
                                sx={{
                                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.2)'
                                    }
                                }}
                            >
                                Edit Profile
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* Main Content */}
            <Grid container spacing={3}>
                {/* Left Sidebar */}
                {/* <Grid item xs={12} md={3}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            bgcolor: '#fff'
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Quick Actions
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {[
                                { icon: <SecurityIcon />, label: 'Security Settings' },
                                { icon: <NotificationsIcon />, label: 'Notifications' },
                                { icon: <LanguageIcon />, label: 'Language & Region' },
                                { icon: <SettingsIcon />, label: 'Account Settings' }
                            ].map((item, index) => (
                                <Button
                                    key={index}
                                    startIcon={item.icon}
                                    sx={{
                                        justifyContent: 'flex-start',
                                        color: '#542374',
                                        '&:hover': {
                                            bgcolor: 'rgba(84, 35, 116, 0.08)'
                                        }
                                    }}
                                >
                                    {item.label}
                                </Button>
                            ))}
                        </Box>
                    </Paper>
                </Grid> */}

                {/* Main Content Area */}
                <Grid item xs={12} md={12}>
                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: 2,
                            bgcolor: '#fff',
                            overflow: 'hidden'
                        }}
                    >
                        <Tabs
                            value={activeTab}
                            onChange={handleTabChange}
                            variant={isMobile ? "scrollable" : "fullWidth"}
                            scrollButtons={isMobile}
                            sx={{
                                borderBottom: 1,
                                borderColor: 'divider',
                                bgcolor: '#f8f9fa'
                            }}
                        >
                            <Tab label="Personal Info" sx={{ textTransform: 'capitalize' }} />
                            {/* <Tab label="Cards" sx={{ textTransform: 'capitalize' }} /> */}
                            <Tab label="Security" sx={{ textTransform: 'capitalize' }} />
                            <Tab label="Preferences" sx={{ textTransform: 'capitalize' }} />
                        </Tabs>

                        <Box sx={{ p: 3 }}>
                            {activeTab === 0 && (
                                <PersonalInfoTab isEditing={isEditing} setIsEditing={setIsEditing} />
                            )}
                            {/* {activeTab === 1 && <CardsTab />} */}
                            {activeTab === 1 && <SecurityTab />}
                            {activeTab === 2 && <PreferencesTab />}
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};

// Personal Info Tab Content
const PersonalInfoTab = ({ isEditing, setIsEditing, isDisabled }) => {
    const [loading, setLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState(null);

    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: ''
    });
    const api = axios.create({
        baseURL: '/api',
        timeout: 5000
    });
    // Fetch user data
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = Cookies.get('token'); // get token from localStorage

                const response = await axios.get('/api/getuser/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setUserData(response.data);
            } catch (error) {
                console.error('Error fetching user data:', error.response?.data || error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);


    // Handle save changes
    const handleSave = async () => {
        setIsSaving(true);
        setError(null);

        try {
            const token = Cookies.get('token');
            const response = await axios.put('https://live.myxpd.app/api/user/profile',
                { address: userData.address },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.status === 200) {
                setUserData(response.data);
                setIsEditing(false);
                toast.success('Address details saved successfully');
            }
        } catch (error) {
            console.error('Error updating address:', error);
            // setError(error.response?.data?.message || 'Failed to update address');
            toast.error('Failed to update address. Please try again.');
        } finally {
            setIsSaving(false);
        }
    };

    // Handle input changes
    const handleChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        });
    };

    if (loading) return <div>Loading...</div>;
    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 3 }}>
                Personal Information
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="First Name"
                        name="firstName"
                        value={userData.firstName}
                        onChange={handleChange}
                        disabled={!isDisabled}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Last Name"
                        name="lastName"
                        value={userData.lastName}
                        onChange={handleChange}
                        disabled={!isDisabled}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        value={userData.email}
                        onChange={handleChange}
                        disabled={!isDisabled}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Phone"
                        name="phone"
                        value={userData.phone}
                        onChange={handleChange}
                        disabled={!isDisabled}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Address"
                        name="address"
                        value={userData.address}
                        onChange={(e) => setUserData(prev => ({
                            ...prev,
                            address: e.target.value
                        }))} disabled={!isEditing}
                        size="small"
                    />
                </Grid>
                {isEditing && (
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                onClick={() => setIsEditing(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleSave}
                                sx={{
                                    bgcolor: '#542374',
                                    '&:hover': {
                                        bgcolor: '#7B3AA0'
                                    }
                                }}
                            >
                                Save Changes
                            </Button>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

// Cards Tab Content
const CardsTab = () => {
    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 3 }}>
                Your Crypto Cards
            </Typography>
            <Grid container spacing={3}>
                {[1, 2].map((card) => (
                    <Grid item xs={12} sm={6} key={card}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                border: '1px solid #e0e0e0',
                                '&:hover': {
                                    borderColor: '#542374'
                                }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                <CreditCardIcon sx={{ color: '#542374' }} />
                                <Typography variant="subtitle1" fontWeight="600">
                                    Virtual Card {card}
                                </Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                                **** **** **** 4789
                            </Typography>
                            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                                <Chip label="Active" size="small" color="success" />
                                <Chip label="Virtual" size="small" variant="outlined" />
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

// Security Tab Content
const SecurityTab = () => {
    // State for password change visibility
    const [showChangePassword, setShowChangePassword] = useState(false);

    // States for password visibility toggles
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // States for error and success messages
    const [passwordError, setPasswordError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    // State for password form data
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    // Handle password field changes
    const handlePasswordChange = (field) => (event) => {
        setPasswordData({
            ...passwordData,
            [field]: event.target.value
        });
        // Clear messages
        setPasswordError('');
        setSuccessMessage('');
    };

    // Password validation
    const validatePasswords = () => {
        if (passwordData.newPassword.length < 8) {
            setPasswordError('New password must be at least 8 characters long');
            return false;
        }
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setPasswordError('New passwords do not match');
            return false;
        }
        return true;
    };

    // Handle password submission
    const handleSubmitPassword = async () => {
        try {
            // Validate passwords
            if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
                setPasswordError('All fields are required');
                return;
            }
    
            if (passwordData.newPassword !== passwordData.confirmPassword) {
                setPasswordError('New passwords do not match');
                return;
            }
    
            if (passwordData.newPassword.length < 8) {
                setPasswordError('Password must be at least 8 characters long');
                return;
            }
    
            setIsSubmitting(true);
            setPasswordError('');
    
            // Get token from localStorage
            const token = Cookies.get('token');
    
            const response = await axios.post(
                `/api/change-password`,
                passwordData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            if (response.data.success) {
                toast.success('Password updated successfully');

                // setSuccessMessage('Password updated successfully');
                // Reset form
                setPasswordData({
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
                // Close form after delay
                setTimeout(() => {
                    setShowChangePassword(false);
                    // setSuccessMessage('');
                }, 3000);
            }
    
        } catch (error) {
            // setPasswordError(error.response?.data?.message || 'Failed to update password');
            toast.error('Failed to update password. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 3 }}>
                Security Settings
            </Typography>
            <Grid container spacing={3}>
                {/* Two-Factor Authentication */}
                <Grid item xs={12}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box>
                                <Typography variant="subtitle1" fontWeight="600">
                                    Two-Factor Authentication
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Add an extra layer of security to your account
                                </Typography>
                            </Box>
                            <Switch defaultChecked />
                        </Box> */}
                        <TwoFactorAuth />
                    </Paper>
                </Grid>

                {/* Change Password Section */}
                <Grid item xs={12}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box>
                                <Typography variant="subtitle1" fontWeight="600">
                                    Password Settings
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Change your account password
                                </Typography>
                            </Box>
                            <Button
                                startIcon={<LockResetIcon />}
                                onClick={() => setShowChangePassword(!showChangePassword)}
                                sx={{
                                    color: '#542374',
                                    '&:hover': {
                                        backgroundColor: 'rgba(84, 35, 116, 0.08)'
                                    }
                                }}
                            >
                                Change Password
                            </Button>
                        </Box>

                        <Collapse in={showChangePassword}>
                            <Box sx={{ mt: 3 }}>
                                {successMessage && (
                                    <Alert
                                        severity="success"
                                        sx={{ mb: 2 }}
                                        onClose={() => setSuccessMessage('')}
                                    >
                                        {successMessage}
                                    </Alert>
                                )}

                                {passwordError && (
                                    <Alert
                                        severity="error"
                                        sx={{ mb: 2 }}
                                        onClose={() => setPasswordError('')}
                                    >
                                        {passwordError}
                                    </Alert>
                                )}

                                <Grid container spacing={2}>
                                    {/* Current Password */}
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Current Password"
                                            type={showCurrentPassword ? 'text' : 'password'}
                                            value={passwordData.currentPassword}
                                            onChange={handlePasswordChange('currentPassword')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                                            edge="end"
                                                        >
                                                            {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    {/* New Password */}
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="New Password"
                                            type={showNewPassword ? 'text' : 'password'}
                                            value={passwordData.newPassword}
                                            onChange={handlePasswordChange('newPassword')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                                            edge="end"
                                                        >
                                                            {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    {/* Confirm New Password */}
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Confirm New Password"
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={passwordData.confirmPassword}
                                            onChange={handlePasswordChange('confirmPassword')}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            edge="end"
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    {/* Action Buttons */}
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                            <Button
                                                variant="outlined"
                                                onClick={() => {
                                                    setShowChangePassword(false);
                                                    setPasswordData({
                                                        currentPassword: '',
                                                        newPassword: '',
                                                        confirmPassword: ''
                                                    });
                                                    setPasswordError('');
                                                }}
                                                sx={{
                                                    borderColor: '#542374',
                                                    color: '#542374',
                                                    '&:hover': {
                                                        borderColor: '#7B3AA0',
                                                        backgroundColor: 'rgba(84, 35, 116, 0.08)'
                                                    }
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleSubmitPassword}
                                                disabled={isSubmitting}
                                                sx={{
                                                    bgcolor: '#542374',
                                                    '&:hover': {
                                                        bgcolor: '#7B3AA0'
                                                    }
                                                }}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <CircularProgress
                                                            size={20}
                                                            sx={{
                                                                color: 'white',
                                                                marginRight: 1
                                                            }}
                                                        />
                                                        Updating...
                                                    </>
                                                ) : (
                                                    'Update Password'
                                                )}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Collapse>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

// Preferences Tab Content
const PreferencesTab = () => {
    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 3 }}>
                Account Preferences
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box>
                                <Typography variant="subtitle1" fontWeight="600">
                                    Email Notifications
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Receive updates about your account activity
                                </Typography>
                            </Box>
                            <Switch defaultChecked />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Profile;
